var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#012169",
    width: "161px",
    height: "161px",
    viewBox: "-3.2 -3.2 38.40 38.40",
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "",
    transform: "matrix(1, 0, 0, 1, 0, 0)rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}")), /*#__PURE__*/React.createElement("title", null, "blog"), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 10,
    height: 2,
    fill: "#012169",
    stroke: "#012169",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 24,
    width: 10,
    height: 2,
    fill: "#012169",
    stroke: "#012169",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 10,
    height: 2,
    fill: "#012169",
    stroke: "#012169",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 18,
    width: 10,
    height: 2,
    fill: "#012169",
    stroke: "#012169",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2v6A2,2,0,0,1,26,14ZM6,6v6H26V6Z",
    transform: "translate(0 0)",
    fill: "#012169",
    stroke: "#012169",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,28H20a2,2,0,0,1-2-2V20a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2v6A2,2,0,0,1,26,28Zm-6-8v6h6V20Z",
    transform: "translate(0 0)",
    fill: "#012169",
    stroke: "#012169",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 32,
    height: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.f1555dd4924dd4c9a2bbbac1611f9f85.svg";
export { ForwardRef as ReactComponent };